import * as React from 'react';
import { useState, useEffect } from 'react';
import EventBus from '../EventBus';
import EnergipresentationAccordion from './EnergipresentationAccordion';
import iEnergipresentationGraphModel from './iEnergipresentationGraph';
import iEnergipresentationGraphPropsModel from './iEnergipresentationGraphProps';
import iEnergipresentationApiRequestModel from "./RequestModels/iEnergipresentationApiRequest";
import iGraphData from './ResponseModels/iGraphData';
import DataHelper from './DataHelper';
import DisplayHelper from './DisplayHelper';
import * as Highcharts from 'highcharts';
import { HighchartsReact } from 'highcharts-react-official';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/pattern-fill';
import EnergipresentationOpenInNewTabButton from './EnergipresentationOpenInNewTabButton';
import EnergipresentationExportButton from './EnergipresentationExportButton';

const EnergipresentationDoubleGraph = (props: iEnergipresentationGraphPropsModel) => {

    const [delayed, setDelayed] = useState(true);
    const [state, setState] = useState<iEnergipresentationGraphModel>(props);

    useEffect(() => {

        getGraphData();
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => setDelayed(false), 3000);
        return () => clearTimeout(timeout);
    }, []);

    const getGraphData = async () => {
        let apiRequest: iEnergipresentationApiRequestModel = {
            blockId: state.blockId,
            lastPublished: state.lastPublished
        };

        await DataHelper.FetchGraphData(apiRequest, initializeGraph);
    }

    const initializeGraph = (graphData: iGraphData) => {
        if (!graphData) {
            return;
        }

        let newState = { ...state };
        newState.decimals = graphData.decimals;
        graphData.chart.marginTop = 20;
        newState.origData = DataHelper.SafeClone(graphData);
        newState.origData.title.text = null;

        let hasPrognose = DisplayHelper.HasPrognoseData(graphData);
        if (hasPrognose) {
            DisplayHelper.DisplayPrognoseArea(graphData);
        }

        newState.textReplacements = DisplayHelper.GetTextReplacementsFromData(graphData, hasPrognose);
        newState.headTitle = DisplayHelper.ReflectDataInText(newState.headTitle, newState.textReplacements);
        graphData.title.text = null;

        newState.graphData = graphData;
        setState(newState);
        if (newState.graphData != null) {
            EventBus.dispatch("GraphDataLoaded", newState.blockId);
        }
    }

    const addSpecificHelpText = (cmsText: string): string => {
        if (!state.graphData?.series?.length || !cmsText) {
            return cmsText;
        }
        let result = DisplayHelper.ReflectDataInText(cmsText, state.textReplacements);
        return result;
    };

    const getTableHeading = () => {
        return (DisplayHelper.ReflectDataInText(state.helpColumnHeaders, state.textReplacements, true)?.split(DisplayHelper.DataDelimiter) || state.graphData?.xAxis?.categories) ?? [];
    };

    const getTable = (): string => {
        if (!state.graphData?.series?.length) {
            return '';
        }
        let heading = getTableHeading();
        let type = state.graphData.chart.type;
        let unit = state.graphData.tooltip.pointFormat.includes('%') ? '%' : state.valueSuffix;
        return DisplayHelper.ToHTMLTable(state.graphData?.series, type, state.headTitle, heading, state.decimals, unit, state.helpInvertTableAxis, state.helpColumnSortOrder);
    };

    return (
        <React.Fragment>
            <h3>{state.headTitle}</h3>
            <div className="graph-container">
                <div className="scroll-container">
                    {(state.graphData != null || delayed) ?
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={state.graphData}
                        />
                        :
                        <div>
                            <p><span className="label label-danger">Fel vid rendering av graf med flera källor</span></p>
                        </div>
                    }
                </div>
            </div>
            <div className="button-wrapper">
                {(state.graphData != null || delayed) && (
                    <EnergipresentationOpenInNewTabButton
                        id={state.blockId}
                        data={state.origData}
                        title={state.headTitle}
                        viewType={state.graphData?.chart?.type}
                        textReplacements={state.textReplacements}
                        columnHeaders={state.helpColumnHeaders}
                        invertTableAxis={state.helpInvertTableAxis}
                        helpTitle={state.helpTitle}
                        helpText={addSpecificHelpText(state.helpText)}
                        table={getTable()}
                        modelStyle={state.helpModelStyle}
                    />
                )}
                {(state.graphData != null || delayed) && (
                    <EnergipresentationExportButton
                        series={state.graphData?.series}
                        type={state.graphData?.chart?.type}
                        title={state.headTitle}
                        heading={getTableHeading()}
                        unit={state.valueSuffix}
                        sortOrder={state.helpColumnSortOrder}
                    />
                )}
            </div>

            {(state.graphData != null || delayed) && state.helpText && state.helpText != "" && (
                <EnergipresentationAccordion
                    key={"accordion_" + state.blockId}
                    title={state.helpTitle}
                    text={addSpecificHelpText(state.helpText)}
                    table={getTable()}
                    modelStyle={state.helpModelStyle}
                />
            )}
        </React.Fragment >
    );
};
export default EnergipresentationDoubleGraph;